import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import { LoadingFull } from '../loading';
import { MdArrowForwardIos } from "react-icons/md";

export const MyShipments = ({data, setData}) => {

  const [trigger, setTrigger] = useState(0);
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const navigate = useNavigate()
  const { auth, user } = useContext(UserContext)
  const userId = user._id
  const token = localStorage.getItem('token')
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (id) => {
    setOpenDropdowns((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  useEffect(() => {
    if (typeof data === 'undefined') {
        axios({
            method: 'post',
            url: '/api/myShipments',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(response => {
            setData(response.data)
        })
        .catch(error => {
            console.log(error);
        });
    }
  }, []);

  return (
    <div class="relative h-full flex flex-col gap-2">
        {(typeof data === 'undefined') ?
            <LoadingFull />
        :
            (data.length > 0) ?
                <div className="shadow-lg py-5 px-10 flex flex-col gap-5">
                    <h2 className="font-semibold text-sm md:text-base">Solgte bøger</h2>
                    <table class="table-auto w-full text-left hidden md:inline-table">
                        <thead className="text-sm">
                            <tr>
                            <th className="pb-4 font-semibold hidden sm:block">Bøger</th>
                            <th className="pb-4 font-semibold">Status</th>
                            <th className="pb-4 font-semibold">Afsendelsesfrist</th>
                            <th className="pb-4 font-semibold sr-only">Status</th>
                            </tr>
                        </thead>
                        <tbody className="text-base">
                            {data.map((ss) => {
                                return (
                                    <tr className="border-t">
                                        <td className="py-4 flex gap-2 flex-wrap">
                                            {ss.products.map((dbId) => 
                                                <div className="bookImage aspect-square w-16 h-auto bg-neutral-100 cursor-pointer">
                                                    <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${dbId}%2F0?alt=media`} alt='BOOK' className="m-auto h-full object-contain bg-neutral-100" />
                                                </div>
                                            )}
                                        </td>   
                                        <td className="py-4">
                                            {ss.status === 0 ?
                                                ss.deliveryType === 3 ?
                                                    <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-200 to-emerald-300 bg-size-200 bg-pos-0 text-emerald-800 font-medium w-fit">
                                                        Afhentes af køber
                                                    </div>
                                                :
                                                    <div className="px-2 py-1 text-sm bg-gradient-to-r from-orange-500 to-orange-600 bg-size-200 bg-pos-0 text-white font-medium w-fit">
                                                        Mangler afsendelse
                                                    </div>
                                            : ss.status === 1 ?
                                                <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-200 to-emerald-300 bg-size-200 bg-pos-0 text-emerald-800 font-medium w-fit">
                                                    Afsendt
                                                </div>
                                            : ss.status === 2 ?
                                                <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-200 to-emerald-300 bg-size-200 bg-pos-0 text-emerald-800 font-medium w-fit">
                                                    Leveret
                                                </div>
                                            : ss.status === 3 ?
                                                <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-600 to-emerald-700 bg-size-200 bg-pos-0 text-white font-medium w-fit">
                                                    Afsluttet
                                                </div>
                                            :
                                                <div className="px-2 py-1 text-sm bg-gradient-to-r from-orange-500 to-orange-600 bg-size-200 bg-pos-0 text-white font-medium w-fit">
                                                    Annulleret
                                                </div>
                                            }
                                        </td>
                                        <td className="py-4">
                                            {ss.status === 0 && ss.deliveryType !== 3 ? ((ss.timeToSend <= 48) ? ss.timeToSend + (ss.timeToSend !== 1 ? " timer" : " time") : Math.ceil(ss.timeToSend/24) + " dage") + " tilbage" : ""}
                                        </td>
                                        <td className="py-4">
                                            {ss.status === 0 ?
                                                ss.deliveryType === 3 ?
                                                    <div className="ml-auto px-5 py-2 w-fit ring-1 ring-emerald-600 cursor-pointer hover:text-white hover:bg-emerald-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                                        Se detaljer
                                                    </div>
                                                :
                                                    <div className="ml-auto px-5 py-2 w-fit ring-1 ring-orange-600 cursor-pointer hover:text-white hover:bg-orange-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                                        Afsend pakken
                                                    </div>
                                            : ss.status === 4 ?
                                                <div className="ml-auto px-5 py-2 w-fit ring-1 ring-orange-600 cursor-pointer hover:text-white hover:bg-orange-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                                    Se detaljer
                                                </div>
                                            :
                                                <div className="ml-auto px-5 py-2 w-fit ring-1 ring-emerald-600 cursor-pointer hover:text-white hover:bg-emerald-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                                    Se detaljer
                                                </div>}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    <div className="flex flex-col md:hidden gap-5">
                        {data.map((ss, index) => {
                            return (
                                <>
                                    <div className="flex flex-col gap-5">
                                        <div className="flex flex-col gap-2">
                                            <div className="flex gap-2 items-center cursor-pointer w-fit" onClick={() => toggleDropdown(ss._id)}>
                                                <h2>Antal bøger:</h2>
                                                <div className="flex gap-2 items-center">
                                                    <p className="font-medium">{ss.products.length}</p>
                                                    <MdArrowForwardIos style={{
                                                        transform: openDropdowns[ss._id] ? 'rotate(90deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.3s ease',
                                                    }} />
                                                </div>
                                            </div>
                                            <div className="flex gap-2" 
                                                style={{
                                                maxHeight: openDropdowns[ss._id] ? '200px' : '0',
                                                overflow: 'hidden',
                                                transition: 'max-height 0.3s ease',
                                            }}>
                                                {ss.products.map((dbId) => 
                                                    <div className="bookImage aspect-square w-16 h-16 bg-neutral-100 cursor-pointer">
                                                        <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${dbId}%2F0?alt=media`} alt='BOOK' className="m-auto h-full object-contain bg-neutral-100" />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="flex gap-2 items-center">
                                                <h2>Status:</h2>
                                                {ss.status === 0 ?
                                                    ss.deliveryType === 3 ?
                                                        <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-200 to-emerald-300 bg-size-200 bg-pos-0 text-emerald-800 font-medium w-fit">
                                                            Afhentes af køber
                                                        </div>
                                                    :
                                                        <div className="px-2 py-1 text-sm bg-gradient-to-r from-orange-500 to-orange-600 bg-size-200 bg-pos-0 text-white font-medium w-fit">
                                                            Mangler afsendelse
                                                        </div>
                                                : ss.status === 1 ?
                                                    <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-200 to-emerald-300 bg-size-200 bg-pos-0 text-emerald-800 font-medium w-fit">
                                                        Afsendt
                                                    </div>
                                                : ss.status === 2 ?
                                                    <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-200 to-emerald-300 bg-size-200 bg-pos-0 text-emerald-800 font-medium w-fit">
                                                        Leveret
                                                    </div>
                                                : ss.status === 3 ?
                                                    <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-600 to-emerald-700 bg-size-200 bg-pos-0 text-white font-medium w-fit">
                                                        Afsluttet
                                                    </div>
                                                :
                                                    <div className="px-2 py-1 text-sm bg-gradient-to-r from-orange-500 to-orange-600 bg-size-200 bg-pos-0 text-white font-medium w-fit">
                                                        Annulleret
                                                    </div>
                                                }
                                            </div>
                                            {ss.status === 0 && ss.deliveryType !== 3 ?
                                                <div className="flex gap-2">
                                                    <h2>Afsendelsesfrist:</h2>
                                                    <p className="font-medium">{((ss.timeToSend <= 48) ? ss.timeToSend + (ss.timeToSend !== 1 ? " timer" : " time") : Math.ceil(ss.timeToSend/24) + " dage") + " tilbage"}</p>
                                                </div>
                                            :
                                                ""}
                                        </div>
                                        {ss.status === 0 ?
                                            ss.deliveryType === 3 ?
                                                <div className="text-center px-5 py-2 w-full ring-1 ring-emerald-600 cursor-pointer hover:text-white hover:bg-emerald-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                                    Se detaljer
                                                </div>
                                            :
                                                <div className="text-center px-5 py-2 w-full ring-1 ring-orange-600 cursor-pointer hover:text-white hover:bg-orange-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                                    Afsend pakken
                                                </div>
                                        : ss.status === 4 ?
                                            <div className="text-center px-5 py-2 w-full ring-1 ring-orange-600 cursor-pointer hover:text-white hover:bg-orange-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                                Se detaljer
                                            </div>
                                        :
                                            <div className="text-center px-5 py-2 w-full ring-1 ring-emerald-600 cursor-pointer hover:text-white hover:bg-emerald-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                                Se detaljer
                                            </div>}
                                    </div>
                                    {index < data.length - 1 ? <hr></hr> : ""}
                                </>
                            )
                        })}
                    </div>
                </div>
            :
                "Du har ingen solgte bøger"
        }
    </div>
  )
}